export class EditReviewModel {
    public id: number;
    public date: string;
}